// this is an autogenerated file from DesignSystem/SeatAction/ConfirmationDialog/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_SeatAction_ConfirmationDialog_Content($id: uuid!) {
  vaxiom_appointment_bookings(where: { _id: { _eq: $id } }) {
    id
    _id
    chair_id
    provider_id
    assistant_id
    location_id
    appointment {
      id
      patient {
        id
        _id
        person {
          id
          first_name
          last_name
          greeting
        }
      }
    }
  }
}

`